<template>
  <div class="refund_bg text_left">
    <title-bar-back :title="'申请售后'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 退款商品 -->
    <div class="order_info">
      <!-- 退款商品店铺 -->
      <order-shop-head />
      <!-- 退款商品信息 -->
      <order-product-list
        v-for="(item, index) in refundProductList"
        :key="index"
        :bgPad="'bg0'"
        :item="item"
        :pageShow="false"
      />
      <!-- <div class="add_btn border_top1px">
        <div
          class="add_product font12 font_weight400 colo087 line_height_30"
          @click="goMoreProduct"
        >
          继续添加
        </div>
      </div> -->
    </div>
    <!-- 多周期鲜奶退款周期 -->
    <div v-if="orderType === 1" class="milk_date clearfix">
      <div class="left">退款周期</div>
      <img
        v-if="refundType === 0"
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right go_right"
        @click="selectDate"
      />
      <div
        v-if="
          refundType === 0 &&
            getPeriodOptionalAfterOrder.unFinishList &&
            getPeriodOptionalAfterOrder.unFinishList.length
        "
        class="right bor_default"
        @click="selectDate"
      >
        第{{ getPeriodOptionalAfterOrder.unFinishList[0].seqNo
        }}<span v-if="getPeriodOptionalAfterOrder.unFinishList.length > 1"
          >~{{
            getPeriodOptionalAfterOrder.unFinishList[
              getPeriodOptionalAfterOrder.unFinishList.length - 1
            ].seqNo
          }}</span
        >期
      </div>
      <div v-if="refundType === 1" class="right bor_default">
        第{{ getPeriodOptionalAfterOrder.finishList[0].seqNo }}期
      </div>
    </div>
    <!-- 货物状态-->
    <div class="total_price1 clearfix" @click="choosePrductStatus">
      <div class="bor_line">
        <span>货物状态</span>
        <img
          src="@/assets/common/icon_back_b87_24@2x.png"
          alt=""
          class="right go_right"
        />
        <div
          :class="{ bor_default: !productStatusList[productStatusIndex] }"
          class="right"
        >
          {{ productStatusList[productStatusIndex] || productStatusDefault }}
        </div>
      </div>
    </div>
    <!-- 退款原因 -->
    <div class="total_price clearfix" @click="chooseRefundReasion">
      <div :class="{ bor_line_bottom: !detail.isMultiCycle }" class="bor_line">
        <span>退款原因</span>
        <img
          src="@/assets/common/icon_back_b87_24@2x.png"
          alt=""
          class="right go_right"
        />
        <div
          :class="{ bor_default: !refundReasionList[refundReasionIndex] }"
          class="right"
        >
          {{ refundReasionList[refundReasionIndex] || refundReasionDefault }}
        </div>
      </div>
    </div>
    <!-- 退款金额 -->
    <div class="total_price1">
      <div class="bor_line clearfix">
        <span>退款金额：</span>
        <span class="refund_price">{{ price | currency(false) }}</span>
        <!-- <div class="refund_pro right">含邮费 ￥100</div> -->
      </div>
    </div>
    <!-- 退款说明 -->
    <div class="total_price clearfix">
      <div class="bor_line bor_line_bottom">
        <van-field
          v-model="refundDet"
          label="退款说明："
          placeholder="选填"
          maxlength="100"
          @blur="reasionBlur"
        />
      </div>
    </div>
    <!-- 上传图片 -->
    <div class="photo_file">
      <div class="total_price photo_title">上传图片（最多6张）</div>
      <div v-if="orderType === 1" class="pic_det">
        注：请上传面单、外包装、内部包装、体现损坏情况的照片
      </div>
      <van-uploader
        v-model="fileList"
        :after-read="afterRead"
        :before-delete="beforeDelete"
        result-type="file"
        max-count="6"
      >
        <div class="up_click">
          <img src="@/assets/order/add_picture.png" alt="" class="up_img" />
          <!-- <p class="up_det up_margin">上传凭证</p>
          <p class="up_det">（最多6张）</p> -->
        </div>
      </van-uploader>
      <!-- </div> -->
    </div>
    <div class="bottom_mar" />
    <!-- 提交 -->
    <div class="submit_btn btn_bg">
      <div class="btn_btn" @click.stop="submit">提交</div>
    </div>
    <!-- 货物状态信息 -->
    <div class="product_status">
      <van-action-sheet v-model="show" title="货物状态" close-icon>
        <div
          v-for="(item, index) in productStatusList"
          :key="index"
          class="total_price clearfix"
        >
          <div class="bor_line" @click="chooseProductItemStatus(index)">
            <span>{{ item }}</span>
            <img
              :src="index === productStatusIndex ? chooseDialogPic : dialogPic"
              alt=""
              class="right go_right"
            />
          </div>
        </div>
        <div class="close_dialog bor_line_bottom">
          <div class="close_btn" @click="closeDialog">关闭</div>
        </div>
      </van-action-sheet>
    </div>
    <!-- 退款原因信息 -->
    <div class="product_status">
      <van-action-sheet v-model="showRefundReasion" title="退款原因" close-icon>
        <div
          v-for="(item, index) in refundReasionList"
          :key="index"
          class="total_price clearfix"
        >
          <div
            :class="{ bor_line_line: index !== 0 }"
            class="bor_line"
            @click="chooseItemRefundReasion(index)"
          >
            <span class="font16">{{ item }}</span>
            <img
              :src="index === refundReasionIndex ? chooseDialogPic : dialogPic"
              alt=""
              class="right go_right"
            />
          </div>
        </div>
        <div class="close_dialog bor_line_bottom">
          <div class="close_btn" @click="closeDialog">关闭</div>
        </div>
      </van-action-sheet>
    </div>

    <!-- 鲜奶收到货退款周期选择 -->
    <div class="product_status">
      <van-action-sheet v-model="showPredictDate" title="退款周期" close-icon>
        <van-checkbox-group checked-color="#E0AF65">
          <van-cell-group>
            <van-cell
              v-for="item in getPeriodOptionalAfterOrder.unFinishList"
              :key="item.seqNo"
              :title="`第${item.seqNo}期 ${item.planDeliveredAt}`"
            >
              <!-- <template>
                <div>
                  {{
                    index === getPeriodOptionalAfterOrder.unFinishList.length - 1
                      ? "可售后"
                      : "不可售后"
                  }}
                </div>
              </template> -->
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <div class="close_dialog bor_line_bottom">
          <div class="close_btn" @click="closePredictDate">关闭</div>
        </div>
      </van-action-sheet>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import OrderShopHead from "../chooserefundtype/components/OrderShopHead";
import OrderProductList from "../../list/components/OrderProductList";
export default {
  name: "ApplyRefund",
  components: {
    TitleBarBack,
    OrderShopHead,
    OrderProductList
  },
  data() {
    return {
      show: false,
      showRefundReasion: false,
      productStatusList: ["未收到货", "已收到货"],
      dialogPic: require("@/assets/login/unselect@2x.png"),
      chooseDialogPic: require("@/assets/login/select@2x.png"),
      productStatusDefault: "请选择",
      productStatusIndex: -1,
      refundReasionList: [
        "质量问题",
        "卖家发错货",
        "收到商品少件或者破损",
        "其他"
      ],
      refundReasionDefault: "请选择",
      refundReasionIndex: -1,
      refundDet: "",
      fileList: [],
      fileListImage: [],
      detail: {},
      refundProductList: [],
      checkAll: [], //是否全选
      freight: 0, //运费
      price: 0,
      refundType: 0,
      showPredictDate: false,
      orderType: 0
    };
  },
  computed: {
    getPeriodOptionalAfterOrder() {
      return this.$store.getters.getPeriodOptionalAfterOrder;
    }
  },
  created() {
    this.orderType = parseInt(localStorage.getItem("mall-wap-refund-type"));
    this.refundType = parseInt(this.$route.query.refundType);
    if (this.orderType === 1) {
      this.getMilkData();
    } else {
      this.refundProductList = JSON.parse(
        localStorage.getItem("mall-wap-refund-list")
      );
    }
  },
  mounted() {
    if (this.orderType === 1) {
      if (this.refundType === 1) {
        this.price = this.getPeriodOptionalAfterOrder.periodPrice;
      } else {
        this.price =
          this.getPeriodOptionalAfterOrder.unFinishList.length *
          this.getPeriodOptionalAfterOrder.periodPrice;
      }
    } else {
      let sum = this.refundProductList.reduce(
        (sum, item) =>
          (sum += (item.skuNowPrice + item.skuTax) * item.modifyNum),
        0
      );
      this.price = sum;
    }
  },
  methods: {
    // 顶部返回
    back() {
      this.$router.back(-1);
    },
    // 获取鲜奶售后数据
    getMilkData() {
      // getPeriodOptionalAfterOrder 鲜奶可申请售后周期
      this.$store
        .dispatch("order/getPeriodOptionalAfterOrder", {
          params: {
            orderSn: this.$route.query.orderSn
          }
        })
        .then(res => {
          this.refundProductList.push(res.skuInfo);
        })
        .catch(() => {});
    },
    // 继续添加商品
    goMoreProduct() {
      this.$router.push(`/order/refund/addproduct`);
    },
    // 多周期鲜奶选择日期
    selectDate() {
      // if (
      //   this.detail.supportAfterSaleFinishedPeriods.length &&
      //   this.$route.query.finish === "true"
      // ) {
      //   this.showPredictDate = true;
      // }
      this.showPredictDate = true;
    },
    // 关闭鲜奶期数弹窗
    closePredictDate() {
      this.showPredictDate = false;
    },
    // 点击货物状态
    choosePrductStatus() {
      this.show = true;
    },
    // 选择货物状态
    chooseProductItemStatus(index) {
      this.productStatusIndex = index;
      this.refundReasionIndex = -1;
      switch (this.productStatusIndex) {
        case 0:
          this.refundReasionList = [
            "多拍/拍错/不想要",
            "快递一直未收到",
            "未按约定时间发货",
            "快递无跟踪记录",
            "其他"
          ];
          break;
        case 1:
          if (this.orderType === 1) {
            this.refundReasionList = [
              "漏发/错发",
              "商品破损/影响正常饮用",
              "商品变质/影响正常饮用",
              "其它"
            ];
          } else {
            this.refundReasionList = [
              "质量问题",
              "卖家发错货",
              "收到商品少件或者破损",
              "其他"
            ];
          }
          break;
      }

      // 货物状态存储
      // localStorage.REFUND_PRODUCT_STATUS_INDEX = index;
      this.show = false;
    },
    // 点击退款原因
    chooseRefundReasion() {
      if (this.productStatusIndex < 0) {
        this.$toast("请先选择货物状态");
        return;
      }
      this.showRefundReasion = true;
    },
    // 选择退款原因
    chooseItemRefundReasion(index) {
      // 退款原因存储
      // localStorage.REFUND_REASIONINDEX = index;
      this.showRefundReasion = false;
      this.refundReasionIndex = index;
    },
    // 退款说明失焦
    reasionBlur() {
      // localStorage.REFUND_DET = this.refundDet;
    },
    // 关闭弹窗
    closeDialog() {
      this.show = false;
      this.showRefundReasion = false;
    },
    // 上传图片
    afterRead(file, detail) {
      // 此时可以自行将文件上传至服务器
      this.$store
        .dispatch("mine/upload", {
          params: {
            file: file.file,
            data: {
              kind: "refund",
              sourceId: this.$route.query.orderSn,
              thumbnail: true
            }
          }
        })
        .then(res => {
          const curItem = { url: res.linkUrl };
          this.$set(this.fileList, detail.index, curItem);
          this.fileListImage.push(res.linkUrl);
        })
        .catch(() => {});
    },
    beforeDelete(index) {
      this.fileList.splice(index, 1);
      this.fileListImage.splice(index, 1);
      // localStorage.REFUND_FILELIST = JSON.stringify(this.fileList);
      // localStorage.REFUND_FILELIST_IMAGE = JSON.stringify(this.fileListImage);
    },
    // 提交申请
    submit() {
      // 先判断货物再判断退款原因
      if (this.productStatusIndex < 0 && this.refundType === 0) {
        this.$toast("请选择货物状态");
        return;
      }
      if (this.refundReasionIndex < 0) {
        this.$toast("请选择退款原因");
        return;
      }
      // addAfterSale
      // 调用申请退款接口 ensureAfterSale
      const items = [];
      this.refundProductList.forEach(item => {
        items.push({
          skuId: item.skuId,
          skuAmount: item.modifyNum || item.skuAmount
        });
      });
      var params = {
        orderSn: this.$route.query.orderSn,
        subOrderSn: this.$route.query.subOrderSn,
        skuList: items,
        afterSaleType: 1,
        goodsReceived:
          this.productStatusIndex < 0 ? 1 : this.productStatusIndex,
        reason: this.refundReasionList[this.refundReasionIndex],
        price: this.price,
        instruction: this.refundDet,
        picUrls: this.fileListImage
      };
      // haveDelivered
      if (this.orderType === 1) {
        params.haveDelivered = this.refundType;
        // applyPeriods
        let applyPeriods = [];
        if (this.refundType === 1) {
          this.getPeriodOptionalAfterOrder.finishList.forEach(item => {
            applyPeriods.push(item.seqNo);
          });
        } else {
          this.getPeriodOptionalAfterOrder.unFinishList.forEach(item => {
            applyPeriods.push(item.seqNo);
          });
        }
        params.applyPeriods = applyPeriods;
      }
      this.$store
        .dispatch("order/addAfterSale", {
          params
        })
        .then(res => {
          this.$router.push({
            path: "/order/refund/refunddetail",
            query: {
              id: res
            }
          });
          // mall-wap-refund-list  mall-wap-refund-type
          localStorage.removeItem("mall-wap-refund-list");
          localStorage.removeItem("mall-wap-refund-type");
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
.order_info {
  /* margin-top: 50px; */
  background: #fff;
}
/* 退款类型 */
.total_price1 {
  margin-top: 10px;
  padding: 0 15px;
  background: #fff;
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
  line-height: 24px;
}
.total_price {
  padding: 0 15px;
  background: #fff;
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
  line-height: 24px;
}
.total_price >>> .van-cell {
  color: #222;
  padding: 0;
  font-size: 12px;
}
.bor_line {
  padding: 12px 0;
}
.bor_line_line {
  border-top: 1px solid #eee;
}
.font16 {
  font-size: 16px;
}
.refund_price {
  color: rgba(254, 6, 0, 1);
  margin-left: 16px;
}
.refund_pro {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
}
.bor_line_bottom {
  border-top: 1px solid #eee;
}
.bor_default {
  color: #999;
}
.go_right {
  width: 24px;
  height: 24px;
}
.refund_det {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
/*  继续添加 */
.add_btn {
  display: flex;
  justify-content: flex-end;
  margin: 0 12px;
  padding: 8px 0 9px 0;
}
.add_product {
  padding: 0 18px;
  border-radius: 2px;
  border: 1px solid #000;
}
/* 鲜奶多周期 */
.milk_date {
  margin: 10px 0;
  background: #fff;
  padding: 15px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 24px;
}
.date_list {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 16px;
}
.milk_date_num {
  display: inline-block;
  width: 40px;
  padding-bottom: 5px;
}
/* 货物状态弹窗 */
.product_status >>> .van-popup--bottom.van-popup--round {
  border-radius: 10px 10px 0px 0px;
}
.product_status >>> .van-popup {
  min-height: 380px;
}
.close_dialog {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
}
.bottom_mar {
  height: 84px;
}
.btn_bg {
  background: #fff;
}
.submit_btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.btn_btn {
  background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  line-height: 50px;
  text-align: center;
  margin: 12px;
}
.close_btn {
  margin: 5px 15px;
  background: linear-gradient(
    270deg,
    rgba(251, 214, 146, 1) 0%,
    rgba(224, 175, 101, 1) 100%
  );
  border-radius: 22px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 40px;
  text-align: center;
}
/* 上传图片 */
.photo_file {
  background: #fff;
  margin-top: 10px;
  padding: 15px;
}
.photo_title {
  padding-bottom: 5px;
  padding-left: 0;
}
.pic_det {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.photo_title >>> .van-uploader__preview-image .van-image__img {
  object-fit: contain !important;
}
.photo_file >>> .van-uploader__preview-image {
  border-radius: 0;
  width: 105px;
  height: 105px;
}
.photo_file >>> .van-uploader__preview {
  margin: 0 12px 8px 0;
}
.up_click {
  width: 105px;
  height: 105px;
  border-radius: 2px;
  border: 1px solid #d8d8d8;
  position: relative;
}
.up_img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
}
.up_margin {
  margin-top: 7px;
}
.up_det {
  font-size: 10px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 14px;
  text-align: center;
}
</style>
